export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./OrganizationInput.vue?vue&type=template&id=5d52cf7a&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/OrganizationInput.vue?vue&type=template&id=5d52cf7a&
// module id = 1145
// module chunks = 0